<!--
 * @Author: your name
 * @Date: 2021-08-05 16:52:04
 * @LastEditTime: 2022-09-02 16:44:56
 * @LastEditors: xunmi muer3mu@126.com
 * @Description: In User Settings Edit
 * @FilePath: \Basic\src\client\App.vue
-->
<template>
  <div class="question-screen" :style="{ backgroundImage: `url('${source.background ? source.background : '/common/images/question/background.jpg'}')` }">
    <div class="question-paper">
      <div class="question-paper-container">
        <div class="question-paper-header"></div>
        <div class="question-paper-body"></div>
        <div class="question-paper-footer"></div>
      </div>
      <template v-if="question && !result">
        <div class="question-header">
          <span>当前为{{ question.answer.length > 1 ? "多选题" : "单选题" }} {{ questions.indexOf(question) + 1 }} / {{ questions.length }}</span>
        </div>
        <div v-if="question" style="max-height: 57vw;position: relative;z-index: 2;overflow: auto;">
          <h3 class="question-title">{{ question.title }}</h3>
          <ul class="question-options">
            <li :class="{ 'question-option-selected': ~question.selected.indexOf(key) }" v-for="(item, key) in question.subject" :key="key" @click="onSelectOption(key, question)">
              <p>{{ key }}： {{ item }}</p>
            </li>
          </ul>
        </div>
        <div class="question-footer">
          <a @click="onPrevious" v-if="index">上一题</a>
          <a @click="onNext">{{ index === questions.length - 1 ? "提交" : "下一题" }}</a>
        </div>
      </template>
      <template v-if="result">
        <div class="question-result">
          <h2>{{ result.allow ? "答题完成" : "哎哟，答错了" }}</h2>
          <p v-if="result.allow">您已经获得抽奖资格</p>
          <p v-else>答对{{ source.limits }}题，才可以获取抽奖资格</p>
        </div>
        <div class="question-footer">
          <template v-if="!result.allow">
            <a @click="result = null" v-if="isReplay">重新答题</a>
            <a @click="onGoHome" v-else>回到首页</a>
          </template>
          <a @click="onSubmit" v-else>去抽奖</a>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "Question",
  props: {
    activityCode: String,
    activity: {
      type: Object,
      default: {},
    },
    source: {
      type: Object,
      default: {},
    },
    user: {
      type: Object,
      default: {},
    },
    checkin: {
      type: Boolean,
      default: false,
    },
    check: {
      type: Object,
      default: null,
    },
    preview: {
      type: Boolean,
      default: false,
    },
    next: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      questions: [],
      question: null,
      index: 0,
      result: null,
    };
  },
  computed: {
    isReplay() {
      return this.activity && this.activity.activityType && this.activity.activityType[1] ? this.activity.activityType[1].replay : false;
    },
  },
  created() {
    console.log("答题页创建", this.user, this.activity.activityType[1]);
    this.$api.question.index({ activityCode: this.activityCode }).then((response) => {
      if (response.length) {
        this.question = response[this.index];
      }

      this.questions = response;
    });
  },
  mounted() {
    this.$store.dispatch("onUserLogSend", {
      pageName: "答题页",
      behavior: { visist: "答题页" },
    });
  },
  methods: {
    onSelectOption(key, question) {
      if (question.answer.length > 1) {
        //TODO 多选题
        if (question.selected.length > 1) {
          if (~question.selected.indexOf(key)) {
            question.selected = question.selected.replace(key, "");
          } else {
            question.selected += key;
          }

          if (question.selected.length > 1) {
            let temp = [];

            for (let i = 0, l = question.selected.length; i < l; i++) {
              temp.push(question.selected.charAt(i));
            }

            question.selected = temp.sort().join("");
            console.log(question.selected);
          }
        } else {
          !~question.selected.indexOf(key) && (question.selected += key);
        }
      } else {
        //TODO 单选题
        question.selected = key;
      }
    },
    onPrevious() {
      if (this.index > 0) {
        this.index--;
        this.question = this.questions[this.index];
      }
    },
    onSuccess(response) {
      //奖品信息response
      return false;
    },
    onFail(response) {
      //错误信息response
      return false;
    },
    onNext() {
      if (this.index >= this.questions.length - 1) {
        //计算结果
        this.onGetResult();
      } else {
        this.index++;
        this.question = this.questions[this.index];
      }
    },
    onGetResult() {
      let limits = Math.min(this.questions.length, this.source.limits),
        rights = 0,
        result = {};

      this.questions.forEach((question) => {
        console.log(question.selected, question.answer);
        if (question.selected === question.answer) {
          rights++;
        }
      });

      result.rights = rights;
      result.allow = rights >= limits;

      if (!result.allow) {
        if (this.isReplay) {
          this.result = result;
        } else {
          this.$api.activity
            .qualifications(this.check)
            .then((response) => {})
            .catch((response) => {})
            .finally(() => {
              this.result = result;
            });
        }
      } else {
        this.result = result;
      }
    },
    onSubmit() {
      if (this.$utils.RequestQuery("preview")) {
        this.$GlobalShowMessage("页面预览测试点击");
        return;
      }
      this.$store.dispatch("onUserLogSend", {
        pageName: "答题页",
        behavior: { click: "答题提交按钮" },
      });

      this.next && this.next(this.onSuccess, this.onFail);

      /* this.$api.activity.luck(this.check)
					  .then(response =>
					  {
						  if (response)
						  {
							  if (response.awardType === '1')
							  {
								  this.$GlobalShowMessage('恭喜你中奖了', '立减金' + response.money + '元', response.img);
								  setTimeout(() => this.$router.replace({ name: 'ActivityRecord' }), 4000);
							  }
							  else
							  {
								  this.$GlobalShowMessage(response.name || '来晚了，谢谢参与', response.img);
							  }
						  }
						  else
						  {
							  this.$GlobalShowMessage('来晚了，谢谢参与');
						  }
					  })
					  .catch(response =>
					  {
						  this.$GlobalShowMessage(response.message || `请检查网络状态`);
						  //setTimeout(() => this.$router.replace({ name: 'ActivityRecord' }), 4000);
					  }); */
    },
    onGoHome() {
      this.$router.replace({ name: "ActivityCheckin" });
    },
  },
};
</script>

<style scoped>
.question-screen {
  position: relative;
  z-index: 2;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  height: 100vh;
  box-sizing: border-box;
  background-image: url(/common/images/question/background.jpg);
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: top center;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 42.5vw;
}

.question-paper {
  /* background-image: url(/common/images/question/paper.png);
	background-position: center;
	background-repeat: no-repeat;
	background-size: contain; */
  box-sizing: border-box;
  width: 90vw;
  min-height: 100vw;
  padding: 21vw 13vw 13vw;
  position: relative;
}

.question-paper-container {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
}

.question-paper-header {
  background-image: url(/common/images/question/paper.header.png);
  background-position: center top;
  background-repeat: no-repeat;
  background-size: 100% auto;
  width: 100%;
  height: 46vw;
}

.question-paper-body {
  background-image: url(/common/images/question/paper.body.png);
  background-position: center top;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  flex-grow: 1;
  flex-shrink: 1;
}

.question-paper-footer {
  background-image: url(/common/images/question/paper.footer.png);
  background-position: center bottom;
  background-repeat: no-repeat;
  background-size: 100% auto;
  width: 100%;
  height: 40.5vw;
}

.question-paper-body {
}

.question-header {
  position: absolute;
  top: 12vw;
  font-size: 3vw;
  color: #aaa;
  text-align: right;
  right: 13vw;
  left: 13vw;
}

.question-title {
  color: #3c3e40;
  font-size: 4vw;
  font-weight: normal;
  margin-bottom: 5vw;
}

.question-options {
  color: #3c3e40;
  font-size: 3.5vw;
}

.question-options li {
  position: relative;
  padding-left: 6vw;
  line-height: 1.5em;
  margin-top: 2vw;
  display: flex;
}

.question-options li:before {
  content: "";
  display: block;
  width: 4vw;
  height: 4vw;
  border: solid 1px #ccc;
  background-color: #fff;
  border-radius: 100%;
  box-sizing: border-box;
  position: absolute;
  left: 0;
  top: 0.5vw;
}

.question-options li.question-option-selected {
  color: #b27d1e;
}

.question-options li.question-option-selected:before {
  border-color: #b27d1e;
  background-color: #b27d1e;
}

.question-options li.question-option-selected:after {
  content: "";
  display: block;
  width: 1.5vw;
  height: 0.75vw;
  border-style: solid;
  border-width: 0 0 2px 2px;
  border-color: transparent transparent #fff #fff;
  position: absolute;
  left: 1vw;
  top: 1.5vw;
  transform: rotate(-45deg);
}

.question-footer {
  display: flex;
  justify-content: space-around;
  position: absolute;
  left: 13vw;
  right: 13vw;
  bottom: 13vw;
}

.question-footer a {
  border: solid 1px #b27d1e;
  color: #b27d1e;
  height: 8vw;
  box-sizing: border-box;
  border-radius: 5vw;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 4vw;
  width: 30vw;
  vertical-align: middle;
  background-color: #fff;
}

.question-result {
  color: #b27d1e;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
  z-index: 2;
}

.question-result h2 {
  font-size: 8vw;
  padding: 8vw 0 6vw;
}

.question-result p {
  font-size: 4vw;
}
</style>
